//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import LoadingShimmer from '@components/atoms/loading-shimmer/LoadingShimmer';

export const SidebarLoadingPlaceholder: React.FunctionComponent<
  React.HTMLAttributes<HTMLDivElement>
> = ({ className }) => {
  return (
    <Container className={className}>
      <PageItemShimmer height='12px' width='90%' />
      <PageItemShimmer height='12px' width='60%' />
      <PageItemShimmer height='12px' width='70%' />
      <PageItemShimmer height='12px' width='90%' />
      <PageItemShimmer height='12px' width='60%' />
      <PageItemShimmer height='12px' width='70%' />
      <PageItemShimmer height='12px' width='90%' />
      <PageItemShimmer height='12px' width='60%' />
      <PageItemShimmer height='12px' width='70%' />
      <PageItemShimmer height='12px' width='90%' />
      <PageItemShimmer height='12px' width='60%' />
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: ${theme.spacings[2]} ${theme.spacings[3]} 0 ${theme.spacings[3]};
`,
);

const PageItemShimmer = styled(LoadingShimmer)(
  ({ theme }) => `
  margin-bottom: ${theme.spacings[3]};
`,
);

export default SidebarLoadingPlaceholder;
